<template>
    <a class="dropdown" :class="classes" @click="activateNotForViewOnly">
        <template v-if="iconType === 'vector'">
            <template v-if="isButton">
                <a class="button">
                    <vector-icon
                        ref="icon"
                        v-tooltip.top="tooltipContent"
                        :icon="icon"
                        fill="#363636"
                        size="21"
                        padding="3"
                    />
                </a>
            </template>
            <template v-else>
                <vector-icon
                    ref="icon"
                    v-tooltip.top="tooltipContent"
                    :icon="icon"
                    fill="#363636"
                    size="21"
                    padding="3"
                />
            </template>
        </template>
        <template v-else>
            <template v-if="isButton">
                <a class="button" type="button">
                    <fa-icon
                        v-if="icon"
                        ref="icon"
                        v-tooltip.top="tooltipContent"
                        :icon="icon"
                        :count="iconCount"
                    />
                </a>
            </template>
            <template v-else>
                <fa-icon
                    v-if="icon"
                    ref="icon"
                    v-tooltip.top="tooltipContent"
                    :icon="icon"
                    :count="iconCount"
                />
            </template>
        </template>

        <span v-if="text">
            {{ text }}
        </span>

        <span v-if="isCount" class="dropdown__count">
            {{ count }}
        </span>

        <div :class="`dropdown-body ${containerClass}`">
            <div class="dropdown-content">
                <slot></slot>
            </div>
        </div>
    </a>
</template>

<script>
import { mapState } from 'pinia';
import stores from 'store/modules';
import dropdownMixin from '../../mixins/components/dropdown';

export default {
    emits: ['icon-click'],

    mixins: [dropdownMixin],

    props: {
        icon: { type: [Object, Array, String, null], default: null },
        iconType: { type: [null, String], default: null },
        text: { type: String, default: null },
        count: { type: Number, default: 0 },
        iconCount: { type: Number, default: null },
        isIntegration: { type: Boolean, default: false },
        isButton: { type: Boolean, default: false },
        isCount: { type: Boolean, default: false },
    },

    computed: {
        ...mapState(stores.User, ['user']),
    },

    methods: {
        onBeforeActivate(e) {
            if (this.isIconClick(e)) {
                this.$emit('icon-click', e);

                return false;
            }
        },

        isIconClick(e) {
            if (
                !this.$options._parentListeners ||
                !this.$options._parentListeners.hasOwnProperty('icon-click')
            ) {
                return false;
            }
            return (
                [...this.$refs.icon.$el.children].findIndex((item) => {
                    return (
                        item === e.target ||
                        [...item.children].findIndex((child) => child === e.target) !== -1
                    );
                }) !== -1
            );
        },

        notForViewOnly() {
            this.$store.dispatch('changeModalChangeRoleRequest', true);
        },

        activateNotForViewOnly(e) {
            if (this.user.role === 'view_only' && this.isIntegration) {
                this.notForViewOnly();
                return;
            }
            this.activate(e);
        },
    },
};
</script>
